import axios from 'axios';

//direccion peticion API
const baseURL = '/api/Noticia';

async function getAllByFechaCreacion(language){
    const { data } = await axios.get(baseURL + "?language=" + language);
    return data;
}

async function getLastByNumber(noticiasToShow, language) {
    const { data } = await axios.get(baseURL+"/ultimas?noticiasToShow=" +noticiasToShow+ "&language=" + language);
    return data;
}

async function getByKey(key, language){
    //NO ENTIENDO LAS URL PACO
    const { data } = await axios.get(baseURL+ "/" +key+ "?language=" + language);
    return data;
}

export default { getAllByFechaCreacion, getLastByNumber,getByKey };
